import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function RequireRole({ allowedRoles = [], children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f8fafc]">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="w-8 h-8 animate-spin text-[#00796b]" />
          <p className="text-xs text-gray-500 font-medium">Verifying access credentials...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    // Determine login target
    let loginRoute = '/customer/login';
    if (allowedRoles.includes('admin') || allowedRoles.includes('super_admin')) {
      loginRoute = '/admin/login';
    } else if (allowedRoles.includes('technician')) {
      loginRoute = '/technician/login';
    }
    return <Navigate to={loginRoute} state={{ from: location }} replace />;
  }

  // Check role match
  const userRole = user.role;
  const isAllowed = allowedRoles.includes(userRole) || 
    (allowedRoles.includes('admin') && (userRole === 'super_admin' || userRole === 'staff'));

  if (!isAllowed) {
    let fallback = '/';
    if (userRole === 'admin' || userRole === 'super_admin' || userRole === 'staff') {
      fallback = '/admin';
    } else if (userRole === 'technician') {
      fallback = '/technician';
    } else if (userRole === 'customer') {
      fallback = '/my-account';
    }
    return <Navigate to={fallback} replace />;
  }

  return children;
}
